import { AreaChart as AreaChartPrimitive } from '@zippeditoolsjs/dashboards';
import { Box, Typography } from '@mui/material';

/**
 * Generic AreaChart wrapper using Tremor via @zippeditoolsjs/dashboards.
 *
 * Props:
 *   data        - array of data objects
 *   indexKey    - field name for the x-axis (Tremor's "index")
 *   valueKeys   - array of field names for the areas (Tremor's "categories")
 *   colors      - array of Tremor color strings
 *   xLabel      - optional x-axis label (display only)
 *   yLabel      - optional y-axis label (display only)
 *   title       - optional chart title
 *   tremorConfig - any extra props spread directly onto AreaChart
 */
export default function AreaChart(props) {
  const {
    data,
    indexKey,
    valueKeys = [],
    colors,
    xLabel,
    yLabel,
    title,
    tremorConfig = {},
  } = props;

  if (!data || data.length === 0) return null;

  return (
    <Box>
      {title && (
        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
          {title}
        </Typography>
      )}
      <AreaChartPrimitive
        data={data}
        index={indexKey}
        categories={valueKeys}
        colors={colors}
        yAxisWidth={48}
        {...tremorConfig}
      />
      {xLabel && (
        <Typography variant="caption" sx={{ display: 'block', textAlign: 'center', mt: 0.5 }}>
          {xLabel}
        </Typography>
      )}
    </Box>
  );
}
